import axios from 'axios';

const ACCESS_TOKEN_KEY = 'cdi_access_token';
const REFRESH_TOKEN_KEY = 'cdi_refresh_token';

export function getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function setTokens({ access, refresh }) {
    if (access) localStorage.setItem(ACCESS_TOKEN_KEY, access);
    if (refresh) localStorage.setItem(REFRESH_TOKEN_KEY, refresh);
}

export function clearTokens() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
}

const http = axios.create({
    baseURL: process.env.VUE_APP_API_URL || '/api',
});

// Adjunta el access token (Bearer) a cada request saliente.
http.interceptors.request.use((config) => {
    const token = getAccessToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Si varias requests reciben 401 al mismo tiempo, solo se pide un refresh
// (se comparte la misma promesa) en vez de disparar varios refresh en paralelo.
let refreshingPromise = null;

function redirigirALogin() {
    if (window.location.pathname !== '/auth/login') {
        window.location.href = '/auth/login';
    }
}

http.interceptors.response.use(
    (response) => response,
    async (error) => {
        const { response, config } = error;
        const esLogin = config?.url?.includes('/auth/login/');

        if (!response || response.status !== 401 || config._retry || esLogin) {
            return Promise.reject(error);
        }

        const refresh = getRefreshToken();
        if (!refresh) {
            clearTokens();
            redirigirALogin();
            return Promise.reject(error);
        }

        config._retry = true;
        try {
            if (!refreshingPromise) {
                refreshingPromise = axios
                    .post(`${http.defaults.baseURL}/auth/login/refresh/`, { refresh })
                    .finally(() => {
                        refreshingPromise = null;
                    });
            }
            const { data } = await refreshingPromise;
            setTokens({ access: data.access });
            config.headers.Authorization = `Bearer ${data.access}`;
            return http(config);
        } catch (refreshError) {
            clearTokens();
            redirigirALogin();
            return Promise.reject(refreshError);
        }
    }
);

export default http;
